export function initChangePassword() {
	const form = document.getElementById('change-password-form');
	const saveBtn = document.querySelector('[data-action="save-password"]');

	if (!form || !saveBtn) {
		return;
	}

	saveBtn.addEventListener('click', async function (e) {
		e.preventDefault();

		// UI Loading
		saveBtn.disabled = true;
		const originalText = saveBtn.textContent;
		saveBtn.textContent = wpcore.direct_t({ en: 'Saving...', fr: 'Enregistrement...' });

		try {
			const formData = new FormData(form);
			formData.append('action', 'save_password');

			const response = await fetch(wpcore.ajaxUrl, {
				method: 'POST',
				body: formData
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const result = await response.json();
			const message = result.data?.message;
			if (result.success) {
				if (window.wpcore && window.wpcore.alert) {
					window.wpcore.alert('success', wpcore.direct_t({ en: 'Update Password', fr: 'Modifier le mot de passe' }), message);
				}
				
				// Clear form
				form.reset();

				// Redirect to login after a short delay
				setTimeout(() => {
					window.location.href = 'login';
				}, 1500);
			} else {
				if (window.wpcore && window.wpcore.alert) {
					window.wpcore.alert('error', wpcore.direct_t({ en: 'Update Password', fr: 'Modifier le mot de passe' }), message);
				} else {
					alert(message);
				}
			}
		} catch (error) {
			console.error('Password change failed:', error);
			const errorMsg = wpcore.direct_t({ en: 'An error occurred. Please try again.', fr: 'Une erreur est survenue. Veuillez réessayer.' });
			if (window.wpcore && window.wpcore.alert) {
				window.wpcore.alert('error', wpcore.direct_t({ en: 'Update Password', fr: 'Modifier le mot de passe' }), errorMsg);
			} else {
				alert(errorMsg);
			}
		} finally {
			saveBtn.disabled = false;
			saveBtn.textContent = originalText;
		}
	});
}
